// SmoothScroll init
import SmoothScroll from 'smooth-scroll';
const smoothScroll = new SmoothScroll('a[href*="#"]', {speed: 150, offset: 88});

// scroll menu + goup
let scrollMenuContainer = document.querySelector('#scroll-menu');
let goupContainer = document.querySelector('#m-goup');
let searchResultsContainer = document.querySelector('.search-results-container');
let lastScrollTop = 0;
let upscrollTimeout = null;


function scroll(e) {
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	// scroll menu
	if (scrollTop > lastScrollTop) {
		// downscroll
		scrollMenuContainer.classList.remove('show-all');
		// @ todo Hide all dropdowns
		searchResultsContainer.classList.add('is-downscrolled');
	} else {
		// upscroll
		scrollMenuContainer.classList.add('show-all');
		searchResultsContainer.classList.remove('is-downscrolled');

	}

	// go up
	if(scrollTop > 600) {
		goupContainer.classList.add('show');
	} else {
		goupContainer.classList.remove('show');
	}

	lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}

window.addEventListener('load', e => {
	const anchor = window.location.hash;
	if (anchor !== '') {
		smoothScroll.animateScroll(document.querySelector(anchor));
		scroll(e);
	}
});

// this makes sure automatic anchor scroll doesn't trigger the scroll handler unless explicitly needed
window.setTimeout(() => window.addEventListener('scroll', scroll, false), 500);
